module.exports = __webpack_public_path__ + "img/Kamer1.25d57864.jpg";